import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { ExtratoContaBmpService } from './extrato-conta-bmp.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-extrato-conta-bmp',
  templateUrl: './extrato-conta-bmp.component.html',
  styleUrls: ['./extrato-conta-bmp.component.scss']
})
export class ExtratoContaBmpComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public formExtratoContaBmp = null;
  public extratoLote = null;
  public extrato = null;
  public rowData = null;
  public columnsTabe = null;
  public tableLimit = 20;
  public listTipoConta = null;
  public cnpjCpf = null;
  public saldoConta = null;
  public customLogin = null;



  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",

  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ExtratoContaBmpService,
    private dateUtilService: DateUtilService,
    private exportCsvService: ExportCsvService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listTipoConta = [
      {
        tipoConta: 'TOP_PESSOA',
        descricao: 'TOP PESSOA'
      },
      {
        tipoConta: 'TOP_EMPRESA',
        descricao: 'TOP EMPRESA'
      },

    ];

    this.formExtratoContaBmp = this.formBuilder.group({
      // saldoConta: [null],
      diaInicio: [null],
      diaFim: [null],
      ano:[null],
      mes:[""],
      tipoConta: [null],
      identificador: [null],
    });

    this.columnsTabe = [
      { columnName: "dataMovimento", newColumnName: "Data Movimento" },
      { columnName: "descricaoOperacao", newColumnName: "Descricao Operacao" },
      { columnName: "vlrMovimento", newColumnName: "Valor" },
      { columnName: "descCliente", newColumnName: "Descricao Cliente" },
      { columnName: "documentoFederal", newColumnName: "Documento Federal" },
      { columnName: "nome", newColumnName: "Nome" },
    ]

  }

  buscarExtrato(data?: any, page?: string) {

    if (!data) return;

    const requiredFields = [
      { key: 'tipoConta', label: 'Tipo da Conta' },
      { key: 'identificador', label: 'Identificador' },
      { key: 'mes', label: 'Mês' },
      { key: 'ano', label: 'Ano' },
      { key: 'diaInicio', label: 'Dia Início' },
      { key: 'diaFim', label: 'Dia Fim' }
    ];

    for (const field of requiredFields) {
      if (!data[field.key]) {
        this.notificationService.error(`${field.label} é obrigatório!`);
        return;
      }
    }

    if (data.diaFim < data.diaInicio) {
      this.notificationService.error('Dia Fim deve ser maior que o Dia Início!');
      return;
    }

    let params = new HttpParams();


    for (let key in data) {
      const value = data[key as keyof typeof data];
      const paramKey = key === 'identificador' ? 'cpfCnpj' : key;
      if (paramKey === 'cpfCnpj') {
        params = params.append(paramKey, this.normalizarCnpjCpfParaBackend(value));
      } else {
        params = params.append(paramKey, String(value));
      }
    }

    params = params.append('size', String(this.tableLimit))

    if (page) {
      params = params.append('page', page)
    }

    this.service.buscaExtratoBmp(params, (response => {

      this.rowData = response.content
      this.extrato = response.content.length;
      this.rowData = this.rowData.map(data => {
        return {
          dataMovimento: this.dateUtilService.formatDate(data.dataMovimento, "DD-MM-YYYY"),
          descricaoOperacao: data.descricaoOperacao,
          vlrMovimento: data.vlrMovimento,
          descCliente: data.descCliente,
          documentoFederal: this.formatarDocumento(data.documentoFederal),
          nome: data.nome
        }
      })

      this.paginationService.setInfo(response)

      if (this.extrato == 0) {
        this.notificationService.warn('Não há dados nesse período!');
      }

    }), null);
  }

  buscarExtratoTotal(data?: any) {

    let params = new HttpParams();

    params = params.append('allElements', 'true');

    if (data.tipoConta === null) {
      this.notificationService.error('Campo Tipo da Conta é obrigatório!');
      return;
    } 
    
    if (data.identificador === null) {
      this.notificationService.error('Campo Identificador é obrigatório!');
      return;
    } 

    for (let key in data){
      const value = data[key as keyof typeof data];
      const paramKey = key === 'identificador' ? 'cpfCnpj' : key;
      if (value){
        if (paramKey === 'cpfCnpj') {
          params = params.append(paramKey, this.normalizarCnpjCpfParaBackend(value));
        } else {
          params = params.append(paramKey, String(value));
        }
      }
    }

    this.service.buscaExtratoBmp(params, (response => {

      this.rowData = response.content
      this.extrato = response.content.length;

      if (this.extrato == 0) {
        this.notificationService.warn('Não há dados para exportar!');
      }

      this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ',', 'extratoBmp');

    }), null);
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.saldoConta = 0;
    this.datatableService.subscribeTable(this.myTable);

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
